import IStrategicMap from 'interfaces/IStrategicMap';
import RestService from './RestService';

export default class StrategicMapService extends RestService<IStrategicMap> {
  constructor() {
    super('strategic-maps');
  }
}
